/**
 * Provide some global constants.
 */

export const greenColorCode = '#376551';
export const lightGreenColorCode = '#ecedeb';
